import { connect } from 'react-redux'
import isThereMoreNotificationsToLoad from '../../reducers/userAccount/selectors/notifications/isThereMoreNotificationsToLoad'
import getNotifications, {
  getNotificationsLoading,
} from '../../reducers/userAccount/selectors/notifications/getNotifications'
import loadNotificationPage from '../../actions/notification/loadMore'
import {
  getNotificationsNotReadCount,
  getNotificationsNotSeenCount,
} from '../../reducers/userAccount/selectors/notifications/getNotificationsCounts'
import { deleteNotification } from '../../actions/notification/notifications'
import Notifications from './Notifications'
import { default as Service } from './NotificationsService'

const mapStateToProps = state => ({
  hasMore: isThereMoreNotificationsToLoad(state),
  isLoading: getNotificationsLoading(state),
  notRead: getNotificationsNotReadCount(state),
  notSeen: getNotificationsNotSeenCount(state),
  notifications: getNotifications(state),
})

const mapDispatchToProps = dispatch => ({
  deleteNotification: (id: number | number[] | 'all') => () =>
    dispatch(deleteNotification(id)),
  loadNotifications: (page: number) => dispatch(loadNotificationPage(page)),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Notifications)

const NotificationsService = connect(
  mapStateToProps,
  mapDispatchToProps,
)(Service)

export { NotificationsService }
